import React, { createContext, useCallback, useContext, useMemo, useState, ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface MenuState {
	start: ReactNode;
	end: ReactNode;
}

interface MenuContextProps {
	menu: MenuState;
	setMenu: (menu: MenuState) => void;
	resetMenu: () => void;
}

const MenuContext = createContext<MenuContextProps | undefined>(undefined);

export const MenuProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const { t } = useTranslation();
	const defaultMenu = useMemo<MenuState>(
		() => ({
			//start: <h2>{t("title")}</h2>,
			start: undefined,
			end: undefined,
		}),
		[t],
	);
	const [menu, setMenu] = useState<MenuState>(defaultMenu);

	const resetMenu = useCallback(() => {
		setMenu(defaultMenu);
	}, [defaultMenu]);

	return (
		<MenuContext.Provider value={{ menu, setMenu, resetMenu }}>
			{children}
		</MenuContext.Provider>
	);
};

export const useMenu = (): MenuContextProps => {
	const context = useContext(MenuContext);
	if (!context) {
		throw new Error("useMenu must be used within a MenuProvider");
	}
	return context;
};